import { render, staticRenderFns } from "./HuliFooter.vue?vue&type=template&id=54633a4e"
import script from "./HuliFooter.vue?vue&type=script&lang=js"
export * from "./HuliFooter.vue?vue&type=script&lang=js"
import style0 from "./HuliFooter.vue?vue&type=style&index=0&id=54633a4e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports